import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { PipeModule } from 'src/app/pipes/pipe.module';
import { MyEventServices } from 'src/app/services/my-event.service';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  selector: 'app-profile-servants',
  templateUrl: './profile-servants.component.html',
  styleUrls: ['./profile-servants.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, PipeModule]
})
export class ProfileServantsComponent implements OnInit, OnDestroy {
  @Input() profileId: number = 0;
  lstServants: any[] = [];
  subscriptions: Subscription[] = [];

  constructor(private profileService: ProfileService, private myEventService: MyEventServices) { }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  ngOnInit() {
    this.lstServants = [];
    //this.myEventService.loadingEvent.emit(true);
    this.subscriptions.push(this.profileService.getProfilesByDataType(this.profileId, 'MyServants').subscribe(result => {
      this.myEventService.loadingEvent.emit(false);
      this.lstServants = result;
    }));
  }

}
